import {
    POST_WHITELISTED_BRAND_LOGIN,
    POST_WHITELISTED_BRAND_LOGIN_SUCCESS,
    POST_WHITELISTED_BRAND_LOGIN_ERROR,
    GET_WHITELISTED_BRANDS,
    GET_WHITELISTED_BRANDS_SUCCESS,
    GET_WHITELISTED_BRANDS_ERROR,
    CREATE_WHITELISTED_BRAND,
    CREATE_WHITELISTED_BRAND_SUCCESS,
    CREATE_WHITELISTED_BRAND_ERROR,
    UPDATE_WHITELISTED_BRAND,
    UPDATE_WHITELISTED_BRAND_SUCCESS,
    UPDATE_WHITELISTED_BRAND_ERROR,
    DELETE_WHITELISTED_BRAND,
    DELETE_WHITELISTED_BRAND_SUCCESS,
    DELETE_WHITELISTED_BRAND_ERROR,
    GET_WHITELISTED_BRANDS_ADMIN_USERS,
    GET_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS,
    GET_WHITELISTED_BRANDS_ADMIN_USERS_ERROR,
    GET_WHITELISTED_BRANDS_USER_MAPPINGS,
    GET_WHITELISTED_BRANDS_USER_MAPPINGS_SUCCESS,
    GET_WHITELISTED_BRANDS_USER_MAPPINGS_ERROR,
    UPDATE_WHITELISTED_BRANDS_USER_MAPPING,
    UPDATE_WHITELISTED_BRANDS_USER_MAPPING_ERROR,
    UPDATE_WHITELISTED_BRANDS_USER_MAPPING_SUCCESS,
    UPDATE_WHITELISTED_BRANDS_ADMIN_USERS,
    UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS,
    UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_ERROR
} from "./actionTypes"

const initialState = {
    whitelisted_brand_login_error: null,
    whitelisted_brand_login: [],
    whitelisted_brand_login_loading: false,
    whitelisted_brands: [],
    whitelisted_brands_loading: false,
    whitelisted_brands_error: null,
    whitelisted_brands_user_mappings: [],
    whitelisted_brands_user_mappings_loading: false,
    whitelisted_brands_user_mappings_error: null,
    whitelisted_brands_admin_users: [],
    whitelisted_brands_admin_users_loading: false,
    whitelisted_brands_admin_users_error: null,
}

const WhitelistedBrandLogin = (state = initialState, action) => {
    switch (action.type) {
        case POST_WHITELISTED_BRAND_LOGIN:
            return {
                ...state,
                whitelisted_brand_login_loading: true
            }

        case POST_WHITELISTED_BRAND_LOGIN_SUCCESS:
            return {
                ...state,
                whitelisted_brand_login: action.payload,
                whitelisted_brand_login_loading: false
            }

        case POST_WHITELISTED_BRAND_LOGIN_ERROR:
            return {
                ...state,
                whitelisted_brand_login_error: action.payload,
                whitelisted_brand_login_loading: false
            }

        case GET_WHITELISTED_BRANDS:
            return {
                ...state,
                whitelisted_brands_loading: true
            }

        case GET_WHITELISTED_BRANDS_SUCCESS:
            return {
                ...state,
                whitelisted_brands: action.payload,
                whitelisted_brands_loading: false
            }

        case GET_WHITELISTED_BRANDS_ERROR:
            return {
                ...state,
                whitelisted_brands_error: action.payload,
                whitelisted_brands_loading: false
            }

        case CREATE_WHITELISTED_BRAND:
            return {
                ...state,
                whitelisted_brands_loading: true,
            }

        case CREATE_WHITELISTED_BRAND_SUCCESS:
            let whitelisted_brand_result = [...state.whitelisted_brands, action.payload]
            whitelisted_brand_result = whitelisted_brand_result.sort((a, b) => a.id - b.id)
            return {
                ...state,
                whitelisted_brands: whitelisted_brand_result,
                whitelisted_brands_loading: false
            }
            
        case CREATE_WHITELISTED_BRAND_ERROR:
            return {
                ...state,
                whitelisted_brands_error: action.payload,
                whitelisted_brands_loading: false
            }

        case UPDATE_WHITELISTED_BRAND:
            return {
                ...state,
                whitelisted_brands_loading: true
            }

        case UPDATE_WHITELISTED_BRAND_SUCCESS:
            const whitelisted_brand_id = action.payload.id
            const unchanged_whitelisted_brands = state.whitelisted_brands.filter(whitelisted_brand => whitelisted_brand.id !== whitelisted_brand_id)
            let updated_whitelisted_brands = [...unchanged_whitelisted_brands, action.payload]
            updated_whitelisted_brands = updated_whitelisted_brands.sort((a, b) => a.id - b.id)
            return {
                ...state,
                whitelisted_brands: updated_whitelisted_brands,
                whitelisted_brands_loading: false
            }

        case UPDATE_WHITELISTED_BRAND_ERROR:
            return {
                ...state,
                whitelisted_brands_error: action.payload,
                whitelisted_brands_loading: false
            }

        case DELETE_WHITELISTED_BRAND:
            return {
                ...state,
                whitelisted_brands_loading: true
            }
            
        case DELETE_WHITELISTED_BRAND_SUCCESS:
            return {
                ...state,
                whitelisted_brands: state.whitelisted_brands.filter(whitelisted_brand => whitelisted_brand.id !== action.payload.id),
                whitelisted_brands_loading: false
            }

        case DELETE_WHITELISTED_BRAND_ERROR:
            return {
                ...state,
                whitelisted_brands_error: action.payload,
                whitelisted_brands_loading: false
            }

        case GET_WHITELISTED_BRANDS_ADMIN_USERS:
            return {
                ...state,
                whitelisted_brands_admin_users_loading: true
            }

        case GET_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS:
            return {
                ...state,
                whitelisted_brands_admin_users: action.payload,
                whitelisted_brands_admin_users_loading: false
            }

        case GET_WHITELISTED_BRANDS_ADMIN_USERS_ERROR:
            return {
                ...state,
                whitelisted_brands_admin_users_error: action.payload,
                whitelisted_brands_admin_users_loading: false
            }

        case UPDATE_WHITELISTED_BRANDS_ADMIN_USERS:
            return {
                ...state,
                whitelisted_brands_admin_users_loading: true
            }

        case UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_SUCCESS:
            const updatedWhitelistedBrandsAdminUsers = state?.whitelisted_brands_admin_users?.map(brand => {
                if (brand?.id === action?.payload?.brand_id) {
                    const targeted_brand = state?.whitelisted_brands_admin_users?.find(brand => brand?.id === action?.payload?.brand_id)
                    const targeted_admin_users = targeted_brand?.users
                    const updated_admin_users = targeted_admin_users?.map(admin_user => {
                        if (admin_user?.id === action?.payload?.admin_user?.id) {
                            return action?.payload?.admin_user
                        }
                        else {
                            return admin_user
                        }}
                    )
                  return {
                    ...brand,
                    users: updated_admin_users
                  };
                } else {
                  return brand;
                }
            });

            return {
                ...state,
                whitelisted_brands_admin_users: updatedWhitelistedBrandsAdminUsers,
                whitelisted_brands_admin_users_loading: false
            }

        case UPDATE_WHITELISTED_BRANDS_ADMIN_USERS_ERROR:
            return {
                ...state,
                whitelisted_brands_admin_users_error: action.payload,
                whitelisted_brands_admin_users_loading: false
            }

        case GET_WHITELISTED_BRANDS_USER_MAPPINGS:
            return {
                ...state,
                whitelisted_brands_user_mappings_loading: true
            }

        case GET_WHITELISTED_BRANDS_USER_MAPPINGS_SUCCESS:
            return {
                ...state,
                whitelisted_brands_user_mappings: action.payload,
                whitelisted_brands_user_mappings_loading: false
            }

        case GET_WHITELISTED_BRANDS_USER_MAPPINGS_ERROR:
            return {
                ...state,
                whitelisted_brands_user_mappings_error: action.payload,
                whitelisted_brands_user_mappings_loading: false
            }

        case UPDATE_WHITELISTED_BRANDS_USER_MAPPING:
            return {
                ...state,
                whitelisted_brands_user_mappings_loading: true
            }

        case UPDATE_WHITELISTED_BRANDS_USER_MAPPING_SUCCESS:
            return {
                ...state,
                whitelisted_brands_user_mappings: action.payload,
                whitelisted_brands_user_mappings_loading: false
            }

        case UPDATE_WHITELISTED_BRANDS_USER_MAPPING_ERROR:
            return {
                ...state,
                whitelisted_brands_user_mappings_error: action.payload,
                whitelisted_brands_user_mappings_loading: false
            }

        default:
            return state
    }
}

export default WhitelistedBrandLogin;
